import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { SettingsRes } from 'features/dashboard'
import { useQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'

export const useFetchMapConfig = () => {
	const axiosPrivate = useAxiosPrivate()
	const {
		data: mapConfig,
		isSuccess: isMapConfigSuccess,
		refetch: refetchMapConfig
	} = useQuery<SettingsRes>({
		queryKey: queryKeys.mapConfig.all,
		queryFn: () => axiosPrivate.get(apiRoutes.widget)
	})

	return {
		mapConfig,
		isMapConfigSuccess,
		refetchMapConfig
	}
}
